export default "__VITE_ASSET__C2CmTc4z__"